// extracted by mini-css-extract-plugin
module.exports = {"button":"NeoDiscoverButton_button__Y_suj","text":"NeoDiscoverButton_text__aGP_Y"};